// The R1 "no medication checks" limit, made visible (PROD-2721 AC1; Samer's ruling on PROD-2673,
// 2026-09-30). No medication safety engine runs today — the licensed interaction engine (Vidal) has
// expired — so wherever a medication is added (the single-order dose dialog, and an order set that
// places medications on the A/P) the physician is told so, plainly, instead of being shown a
// reassuring result from a check that never ran.
//
// A neutral notice, not an error: the DS `Banner` info variant. The copy is decided; keep it
// verbatim.
import { Banner } from '@scripsteam/scrips-signal-ds';

export const NO_MEDICATION_CHECKS_LEAD = 'No medication checks:';
export const NO_MEDICATION_CHECKS_BODY =
  "allergies, interactions and doses aren't checked automatically. Review each medication before signing.";
/** The full sentence, as the notice reads. */
export const NO_MEDICATION_CHECKS_COPY = `${NO_MEDICATION_CHECKS_LEAD} ${NO_MEDICATION_CHECKS_BODY}`;

export function NoMedicationChecksNotice({ className }: { className?: string }) {
  return (
    <Banner variant="info" role="note" aria-label="No medication checks" className={className}>
      <strong>{NO_MEDICATION_CHECKS_LEAD}</strong> {NO_MEDICATION_CHECKS_BODY}
    </Banner>
  );
}
